/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SpecificVersionInfo
 */
export interface SpecificVersionInfo {
  /**
   * Name of the versioned item
   * @type {string}
   * @memberof SpecificVersionInfo
   */
  id: string
  /**
   * Version of the item
   * @type {string}
   * @memberof SpecificVersionInfo
   */
  version: string
}

/**
 * Check if a given object implements the SpecificVersionInfo interface.
 */
export function instanceOfSpecificVersionInfo(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'version' in value

  return isInstance
}

export function SpecificVersionInfoFromJSON(json: any): SpecificVersionInfo {
  return SpecificVersionInfoFromJSONTyped(json, false)
}

export function SpecificVersionInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SpecificVersionInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['Id'],
    version: json['Version'],
  }
}

export function SpecificVersionInfoToJSON(
  value?: SpecificVersionInfo | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    Id: value.id,
    Version: value.version,
  }
}
